import React, { Component } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Dashboard from '../containers/dashboard';
import LoginView from '../containers/login';
import Terms from '../containers/terms';
import {
  ProjectDetail, ProjectDetailPage, ProjectDetailAdd, ProjectDetailEdit, ProjectManager, Regokas,
  MemberLicense, Regokasassigned, Regokasunassigned, Support, Help, DesignHelp, OfficeLocation,
  Chat, SystemIntegratorAddPage, DistributorSubscriptionPage, MemberLicenseDistributorPage,
  AssignOkasBoxPage, OkasAssignedBoxPage, OkasUnassignedBoxPage, OkasInventoryPage,
  DistributorHelpPage1, NotificationSeeMorepage, KnowledgeBankpage, KnowledgeBankpage2,
  UpcommingEventsPage, UpcommingEventsPage2, VideoPage, VideoPage2, WhatsNewPage, WhatsNewPage2,
  Support2, RemoteAccessPage, RemoteAccessPage2, UserProfilepage, UserProfilepage2, Userpage, Userpage2,
  UserRolespage, UserRolespage2, UserTreeChartpage2, UserTreeChartpage, UserMarketPlacePage2, UserMarketPlacePage
} from './../containers/Pages';
import DashboardDistributor from '../distributorHome/dashboard';
import ApproveDistributor from '../views/ApporveDistributorPage';
import Payment from '../views/Payment';
import SupportRemoteRequest from '../views/SupportRemoteAccess';
import SupportRemote from './SupportRemote';
import SupportRemoteDistributor from './SupportRemoteDistributor';
import ApprovePage from '../views/Apporvepage';
import RemoteAccessWindow from './RemoteAccessWindow';
import RemoteAccessWindowDistributor from './RemoteAccessWindowDistributor';
import '../css/core.css';
import '../css/root.css';
import UserTree from '../containers/userTreeMain';
import ProtectedRoute from './protectedRoute';
import NotFound from './notFoundPage';

class Root extends Component {
  render() {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/usertree" element={<UserTree />} />
          <Route path="/usertreechart" element={<UserTreeChartpage />} />
          <Route path="/usertreechart2" element={<UserTreeChartpage2 />} />
          {/* <Route path="/" element={
            <ProtectedRoute element={<Dashboard />} allowedUserTypes={[1, 3]} />
          } /> */}
          <Route path="/login" element={<LoginView />} />
          <Route path="/login/session-timeout" element={<LoginView />} />
          <Route path="/login/activateuser/:id" element={<LoginView />} />
          <Route path="/login/forget-password" element={<LoginView />} />
          <Route path="/login/forgetpassword" element={<LoginView />} />
          <Route path="/login/forgotpassword/:id" element={<LoginView />} />
          <Route path="/" element={<Dashboard />} />
          {/* <Route path="/dashboard" element={<Dashboard />} /> */}
          {/* <Route path="/memberlicense" element={<MemberLicense />} /> */}
          {/* <Route path="/regokas" element={<Regokas />} /> */}
          {/* <Route path="/notifications" element={<NotificationSeeMorepage />} /> */}
          {/* <Route path="/knowledgebank" element={<KnowledgeBankpage />} /> */}
          {/* <Route path="/knowledgebank2" element={<KnowledgeBankpage2 />} /> */}
          {/* <Route path="/userpage" element={<Userpage />} /> */}
          {/* <Route path="/userpage2" element={<Userpage2 />} /> */}
          {/* <Route path="/upcommingevents" element={<UpcommingEventsPage />} /> */}
          {/* <Route path="/upcommingevents2" element={<UpcommingEventsPage2 />} /> */}
          {/* <Route path="/video" element={<VideoPage />} /> */}
          {/* <Route path="/video2" element={<VideoPage2 />} /> */}
          {/* <Route path="/whatsnew" element={<WhatsNewPage />} /> */}
          {/* <Route path="/whatsnew2" element={<WhatsNewPage2 />} /> */}
          {/* <Route path="/assignokasbox" element={<OkasInventoryPage />} /> */}
          {/* <Route path="/okasunassignedbox" element={<OkasUnassignedBoxPage />} /> */}
          {/* <Route path="/projectdetail" element={<ProjectDetail />} /> */}
          {/* <Route path="/projectdetailadd" element={<ProjectDetailAdd />} /> */}
          {/* <Route path="/projectdetailedit" element={<ProjectDetailEdit />} /> */}
          {/* <Route path="/projectmanager" element={<ProjectManager />} /> */}
          {/* <Route path="/officelocation" element={<OfficeLocation />} /> */}
          {/* <Route path="/support" element={<Support />} /> */}
          {/* <Route path="/support2" element={<Support2 />} /> */}
          {/* <Route path="/support/:id" element={<SupportRemote />} /> */}
          {/* <Route path="/support2/:id" element={<SupportRemoteDistributor />} /> */}
          {/* <Route path="/remote-access" element={<RemoteAccessPage />} /> */}
          {/* <Route path="/remote-access2" element={<RemoteAccessPage2 />} /> */}
          {/* <Route path="/approve" element={<ApprovePage />} /> */}
          {/* <Route path="/approve2" element={<ApproveDistributor />} /> */}
          {/* <Route path="/support/remote-access/:port" element={<RemoteAccessWindow />} /> */}
          {/* <Route path="/support2/remote-access2/:port" element={<RemoteAccessWindowDistributor />} /> */}
          {/* <Route path="/profile" element={<UserProfilepage />} /> */}
          {/* <Route path="/profile2" element={<UserProfilepage2 />} /> */}
          {/* <Route path="/roles" element={<UserRolespage />} /> */}
          {/* <Route path="/roles2" element={<UserRolespage2 />} /> */}
          {/* <Route path='/marketplace' element={<UserMarketPlacePage />} /> */}
          {/* <Route path='/marketplace2' element={<UserMarketPlacePage2 />} /> */}
          {/* <Route path="/help" element={<Help />} /> */}
          {/* <Route path="/memberlicence" element={<MemberLicenseDistributorPage />} /> */}
          {/* <Route path="/systemintegratoradd" element={<SystemIntegratorAddPage />} /> */}
          {/* <Route path="/distributorsubscription" element={<DistributorSubscriptionPage />} /> */}
          {/* <Route path="/distributorshelppage" element={<DistributorHelpPage1 />} /> */}
          {/* <Route path="/dashboardnew" element={<DashboardDistributor />} /> */}

          <Route path="/dashboard" element={
            <ProtectedRoute element={<Dashboard />} allowedUserTypes={[1, 3]} />
          } />
          <Route path="/memberlicense" element={
            <ProtectedRoute element={<MemberLicense />} allowedUserTypes={[1]} allowedUserSources={['SI']} />
          } />
          <Route path="/regokas" element={
            <ProtectedRoute element={<Regokas />} allowedUserTypes={[1, 4]} allowedUserSources={['SI']} requiredModuleKey="inventory" />
          } />
          <Route path="/notifications" element={
            <ProtectedRoute element={<NotificationSeeMorepage />} allowedUserTypes={[1, 4]} allowedUserSources={['SI']} />
          } />
          <Route path="/knowledgebank" element={
            <ProtectedRoute element={<KnowledgeBankpage />} allowedUserTypes={[3, 4]} allowedUserSources={['Distributor']} />
          } />
          <Route path="/knowledgebank2" element={
            <ProtectedRoute element={<KnowledgeBankpage2 />} allowedUserTypes={[1, 4]} allowedUserSources={['SI']} />
          } />
          <Route path="/userpage" element={
            <ProtectedRoute element={<Userpage />} allowedUserTypes={[3, 4]} allowedUserSources={['Distributor']} requiredModuleKey="user" />
          } />
          <Route path="/userpage2" element={
            <ProtectedRoute element={<Userpage2 />} allowedUserTypes={[1, 4]} allowedUserSources={['SI']} requiredModuleKey="user" />
          } />
          <Route path="/market-place-payment" element={<Payment />} />
          <Route path="/upcommingevents" element={
            <ProtectedRoute element={<UpcommingEventsPage />} allowedUserTypes={[3, 4]} allowedUserSources={['Distributor']} />
          } />
          <Route path="/upcommingevents2" element={
            <ProtectedRoute element={<UpcommingEventsPage2 />} allowedUserTypes={[1, 4]} allowedUserSources={['SI']} />
          } />
          <Route path="/video" element={
            <ProtectedRoute element={<VideoPage />} allowedUserTypes={[3, 4]} allowedUserSources={['Distributor']} />
          } />
          <Route path="/video2" element={
            <ProtectedRoute element={<VideoPage2 />} allowedUserTypes={[1, 4]} allowedUserSources={['SI']} />
          } />
          <Route path="/whatsnew" element={
            <ProtectedRoute element={<WhatsNewPage />} allowedUserTypes={[3, 4]} allowedUserSources={['Distributor']} />
          } />
          <Route path="/whatsnew2" element={
            <ProtectedRoute element={<WhatsNewPage2 />} allowedUserTypes={[1, 4]} allowedUserSources={['SI']} />
          } />
          <Route path="/assignokasbox" element={
            <ProtectedRoute element={<OkasInventoryPage />} allowedUserTypes={[3, 4]} allowedUserSources={['Distributor']} requiredModuleKey="okas inventory" />
          } />
          <Route path="/okasunassignedbox" element={
            <ProtectedRoute element={<OkasUnassignedBoxPage />} allowedUserTypes={[3, 4]} allowedUserSources={['Distributor']} requiredModuleKey="okas inventory" />
          } />
          <Route path="/okasassignedbox" element={<OkasAssignedBoxPage />} />
          <Route path="/regokasunassigned" element={<Regokasunassigned />} />
          <Route path="/regokasassigned" element={<Regokasassigned />} />
          <Route path="/projectdetail" element={
            <ProtectedRoute element={<ProjectDetail />} allowedUserTypes={[1, 2, 4]} allowedUserSources={['SI']} requiredModuleKey="project detail" />
          } />
          <Route path="/projectdetailpage" element={<ProjectDetailPage />} />
          <Route path="/projectdetailadd" element={
            <ProtectedRoute element={<ProjectDetailAdd />} allowedUserTypes={[1, 2, 4]} allowedUserSources={['SI']} requiredModuleKey="project detail" />
          } />
          <Route path="/projectdetailedit" element={
            <ProtectedRoute element={<ProjectDetailEdit />} allowedUserTypes={[1, 2, 4]} allowedUserSources={['SI']} requiredModuleKey="project detail" />
          } />
          <Route path="/projectmanager" element={
            <ProtectedRoute element={<ProjectManager />} allowedUserTypes={[1, 4]} allowedUserSources={['SI']} requiredModuleKey="project manager" />
          } />
          <Route path="/officelocation" element={
            <ProtectedRoute element={<OfficeLocation />} allowedUserTypes={[1, 4]} allowedUserSources={['SI']} requiredModuleKey="office location" />
          } />
          <Route path="/support" element={ 
            <ProtectedRoute element={<Support />} allowedUserTypes={[1, 4]} allowedUserSources={['SI']} requiredModuleKey='support' /> 
          } /> 
          <Route path="/support2" element={ 
            <ProtectedRoute element={<Support2 />} allowedUserTypes={[3, 4]} allowedUserSources={['Distributor']} requiredModuleKey='support' />
          } /> 
          <Route path="/support/:id" element={ 
            <ProtectedRoute element={<SupportRemote />} allowedUserTypes={[1, 4]} allowedUserSources={['SI']} requiredModuleKey='support' />
          } /> 
          <Route path="/support2/:id" element={ 
            <ProtectedRoute element={<SupportRemoteDistributor />} allowedUserTypes={[3, 4]} allowedUserSources={['Distributor']} requiredModuleKey='support' /> 
          } /> 
          <Route path="/remote-access" element={ 
            <ProtectedRoute element={<RemoteAccessPage />} allowedUserTypes={[1, 4]} allowedUserSources={['SI']} requiredModuleKey='support' /> 
          } />
          <Route path="/remote-access2" element={ 
            <ProtectedRoute element={<RemoteAccessPage2 />} allowedUserTypes={[3, 4]} allowedUserSources={['Distributor']} requiredModuleKey='support' /> 
          } />
          <Route path="/approve" element={ 
            <ProtectedRoute element={<ApprovePage />} allowedUserTypes={[1, 4]} allowedUserSources={['SI']} requiredModuleKey='support' />
          } />
          <Route path="/approve2" element={ 
            <ProtectedRoute element={<ApproveDistributor />} allowedUserTypes={[3]} allowedUserSources={['Distributor']} requiredModuleKey='support' />
          } /> 
          <Route path="/support/remote-access/:port" element={
            <ProtectedRoute element={<RemoteAccessWindow />} allowedUserTypes={[1, 4]} allowedUserSources={['SI']} requiredModuleKey='support' />
          } />
          <Route path="/support2/remote-access2/:port" element={
            <ProtectedRoute element={<RemoteAccessWindowDistributor />} allowedUserTypes={[3, 4]} allowedUserSources={['Distributor']} requiredModuleKey='support' />
          } />
          <Route path="/chat" element={<Chat />} />
          <Route path="/help" element={
            <ProtectedRoute element={<Help />} allowedUserTypes={[1, 4]} allowedUserSources={['SI']} />
          } />
          <Route path="/memberlicence" element={
            <ProtectedRoute element={<MemberLicenseDistributorPage />} allowedUserTypes={[3, 4]} allowedUserSources={['Distributor']} requiredModuleKey="member licence" />
          } />
          <Route path="/design-help" element={<DesignHelp />} />
          <Route path="/terms" element={<Terms />} />
          {/* <Route path="/profile" element={<Distributor><UserProfilepage /></Distributor>} /> */}
          <Route path="/profile" element={
            <ProtectedRoute element={<UserProfilepage />} allowedUserTypes={[3, 4]} allowedUserSources={['Distributor']} />
          } />
          <Route path="/profile2" element={
            <ProtectedRoute element={<UserProfilepage2 />} allowedUserTypes={[1, 4]} allowedUserSources={['SI']} />
          } />
          <Route path="/roles" element={
            <ProtectedRoute element={<UserRolespage />} allowedUserTypes={[3, 4]} allowedUserSources={['Distributor']} requiredModuleKey="role" />
          } />
          <Route path="/roles2" element={
            <ProtectedRoute element={<UserRolespage2 />} allowedUserTypes={[1, 4]} allowedUserSources={['SI']} requiredModuleKey="role" />
          } />
          <Route path="/marketplace" element={
            <ProtectedRoute element={<UserMarketPlacePage />} allowedUserTypes={[3]} allowedUserSources={['Distributor']} />
          } />
          <Route path="/marketplace2" element={
            <ProtectedRoute element={<UserMarketPlacePage2 />} allowedUserTypes={[1]} allowedUserSources={['SI']} />
          } />
          <Route path="/systemintegratoradd" element={
            <ProtectedRoute element={<SystemIntegratorAddPage />} allowedUserTypes={[3, 4]} allowedUserSources={['Distributor']} requiredModuleKey="system integrator" />
          } />
          <Route path="/distributorsubscription" element={
            <ProtectedRoute element={<DistributorSubscriptionPage />} allowedUserTypes={[3]} allowedUserSources={['Distributor']} />
          } />
          <Route path="/distributorshelppage" element={
            <ProtectedRoute element={<DistributorHelpPage1 />} allowedUserTypes={[3, 4]} allowedUserSources={['Distributor']} />
          } />
          <Route path="/okasinventory" element={<OkasInventoryPage />} />
          <Route path="/dashboardnew" element={
            <ProtectedRoute element={<DashboardDistributor />} allowedUserTypes={[3]} />  // Distributor Dashboard
          } />
          {/* Catch-all 404 route should be at the bottom */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    );
  }
}

export default Root;